import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useCreateSegment } from '@occc/feat-segments';
import { SegmentCreate, SegmentCreateMutation } from '@occc/graphql';
import { useChainId } from '@occc-app/Chain/hooks';

import { SegmentForm } from '../components/SegmentForm';
import { routeCreator } from '../utils';

export const createSegmentFormId = 'createSegmentForm';

const initialValues = {
  name: '',
  description: '',
  shortCode: '',
};

export const CreateSegmentFormContainer: React.FC = () => {
  const navigate = useNavigate();
  const chainId = useChainId();

  const onCompleted = (mutation: SegmentCreateMutation) => {
    // TODO: change navigateTo to navigate
    navigate(routeCreator.details(mutation.segmentCreate.id));
  };
  const [segmentCreate] = useCreateSegment({
    onCompleted,
    refetchQueries: ['segment'],
  });
  const onSubmit = (input: SegmentCreate) =>
    segmentCreate({
      variables: {
        chainId,
        input,
      },
    });

  return (
    <SegmentForm
      id={createSegmentFormId}
      readOnly={false}
      editMode={false}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  );
};

export default CreateSegmentFormContainer;
